import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  align-items: flex-start;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 32px;
  gap: 16px;
`;

export const Text = styled.h4`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
`;
